export default "__VITE_ASSET__B66qM4ww__"